// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function useDelayedBoolean(delay, mode, input) {
  var match = React.useState(function () {
    return input;
  });
  var setResult = match[1];
  var timeoutId = React.useRef(undefined);
  var $$clearTimeout$1 = function (param) {
    Belt_Option.forEach(timeoutId.current, function (prim) {
      clearTimeout(prim);
    });
  };
  React.useEffect(function () {
    return $$clearTimeout$1;
  }, []);
  React.useEffect(function () {
    var shouldDelay;
    switch (mode) {
      case /* DelayTruth */0:
        shouldDelay = input;
        break;
      case /* DelayFalse */1:
        shouldDelay = !input;
        break;
      case /* DelayBoth */2:
        shouldDelay = true;
        break;
    }
    if (shouldDelay) {
      timeoutId.current = Caml_option.some(setTimeout(function (param) {
        Curry._1(setResult, function (param) {
          return input;
        });
      }, delay));
    } else {
      $$clearTimeout$1(undefined);
      Curry._1(setResult, function (param) {
        return input;
      });
    }
  }, [input]);
  return match[0];
}
export { useDelayedBoolean };
/* react Not a pure module */